import React from 'react';
import Header from '../Header';
import { Box } from '@mui/material';
import SwitchPortsTable from '../tables/distro/SwitchPortsTable';
import { useParams } from 'react-router-dom';
import { IspNameDataType } from '../../types/buildingTypes';
import Typography from '@mui/material/Typography';
import BrokenLinkPage from './BrokenLinkPage';
import { useRequiredSearchParams } from '../../hooks/useRequiredSearchParams';
import DynamicBreadcrumbs from '../breadcrumbs/DynamicBreadcrumbs';
import pageStyles from './pageStyles';

function IspDevicesPage() {
  const { isp } = useParams<IspNameDataType>();
  const { params, isValid } = useRequiredSearchParams(['region', 'building', 'vendor', 'site']);

  if (!isValid || !isp) return <BrokenLinkPage />;

  return (
    <>
      <Header />
      <Box sx={{ margin: 'auto', width: '80%' }}>
        <Box sx={pageStyles.dynamicBreadcrumbs}>
          <DynamicBreadcrumbs />
        </Box>
        <Typography sx={pageStyles.label} component="h1" variant="h4" align="center">
          ISP manager - IP: {isp}, Region: {params.region}
        </Typography>
        <SwitchPortsTable
          device="isp"
          deviceIP={isp}
          selectedRegion={params.region}
          selectedBuilding={params.building}
          selectedVendor={params.vendor}
          selectedSite={params.site}
        />
      </Box>
    </>
  );
}

export default IspDevicesPage;
